import React from 'react';
import ProgramPage from '../components/ProgramPage';
import WhatsAppButton from '../components/WhatsAppButton';
function Programs() {
  return (
    <div className="home">
    <ProgramPage />
    <WhatsAppButton />
    </div>
  );
}

export default Programs;
